// extracted by mini-css-extract-plugin
export default {"submitButton":"fillDetail_submitButton__6ovBy"};